<template>
  <div class="orm-container-fluid orm-reservationInfobar">
    <div class="orm-container">
      <div class="orm-row center-xl left-lg">
        <div class="orm-col-xs-12 orm-col-md-8 orm-col-lg-12 orm-padding20">
          <div class="orm-row">
            <div
              class="orm-col-xs-12 orm-col-sm-6"
              :class="step <= 1 ? 'orm-col-lg-3' : 'orm-col-lg-2'"
              v-if="
                store.getters['ORMgeneral/GET_PARAMETER'](
                  'BORM_ABO_ALL_STAT'
                ) !== '1' && step <= 1
              "
            >
              <div class="orm-searchbar__headline">
                <strong v-if="step <= 1">{{ i18n("general/station") }}</strong>
                <strong v-else>&nbsp;</strong>
              </div>
              <stationpicker
                class=""
                :data="stations"
                type="start"
                :readonly="step <= 1 ? false : true"
                :border="step <= 1 ? true : false"
              />
            </div>
            <div
              v-if="
                selectedStation &&
                  step >= 1 &&
                  store.getters['ORMgeneral/GET_PARAMETER'](
                    'BORM_ABO_ALL_STAT'
                  ) !== '1'
              "
              class="orm-col-xs-12 orm-col-sm-6"
              :class="step <= 1 ? 'orm-col-lg-3' : 'orm-col-lg-2'"
            >
              <div>
                <strong> {{ selectedStation.name }}</strong>
              </div>
              <small>
                {{ selectedStation.street }}, {{ selectedStation.city }}
              </small>
            </div>

            <div class="orm-relative orm-col-xs-12 orm-col-sm-6 orm-col-lg-3">
              <Datepicker
                :start-only="true"
                :infobar="false"
                :readonly="false"
                viewType="mapModule"
                @update:date="$emit('update')"
                v-if="step <= 2"
              />
              <div v-else>
                <div class="orm-row no-margin orm-ml-8 orm-mt-16 text-small">
                  <div class="orm-pr-16">
                    <i class="fal fa-calendar-alt"></i>
                  </div>
                  <div>
                    <strong>
                      {{ formateDateDayLong(selectedDate.start) }}</strong
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="orm-relative orm-col-xs-12 orm-col-sm-6 orm-col-lg-3">
              <FormSelect
                :data="aboPerVehicle"
                :selected="selectedAbo"
                myOptionsText="key"
                optionlabel=" Monate"
                optionkey="key"
                icon="fal fa-clock"
                :readonly="false"
                :title="i18n('search/label/minabo_title') || 'Laufzeit'"
                @selected="selectAbo"
                v-if="step <= 2"
              />
              <div v-else>
                <div
                  class="orm-row no-margin orm-ml-8 orm-mt-16 orm-mb-16 orm-md-mb-0 text-small"
                >
                  <div>
                    <strong>
                      {{ selectedAbo[0] }}
                      {{ i18n("general/abo_unit") || "Monate" }}
                      {{
                        i18n("step2/minduration") || "Mindestlaufzeit"
                      }}</strong
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import store from "@/store";
import i18n from "@/mixins/mixins";

import stationpicker from "@/components/ui/stationpicker.vue"; // @ is an alias to /src
// import SimpleSelect from "@/components/ui/INPUTS/SimpleSelect.vue"; // @ is an alias to /src
import FormSelect from "@/components/ui/INPUTS/FormSelectHeader.vue"; // @ is an alias to /src
import Datepicker from "@/components/ui/datepicker-startonly.vue"; // @ is an alias to /src
import { formateDateDayLong } from "@/constants/formater";

export default defineComponent({
  name: "infobar_abo",
  components: { stationpicker, Datepicker, FormSelect },
  mixins: [i18n],
  emits: ["update"],
  props: {
    data: Object,
    type: String,
    step: Number,
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    selectedStation: Object,
  },
  setup() {
    let stations = store.getters["stations/GET_STATIONS"];
    const filtered = store.getters["stations/GET_STATIONS_FILTERED"];
    const type = store.getters["userSession/GET_STATIONTYPE"];

    if (type) {
      stations = filtered[type];
    }

    return {
      stations,
      store,
      formateDateDayLong,
    };
  },
  data() {
    return {
      selectedDate: store.getters["reservation/GET_RESERVATION_DATE"],
      stationSelected: store.getters["userSession/GET_STATION"],
      stationSelectedEnd: store.getters["userSession/GET_STATION_END"],
      selectedAbo: store.getters["reservation/GET_SELECTEDABO"],
      aboPerVehicle: [],
    };
  },
  async mounted() {
    const vehicle = await store.getters["userSession/GET_VEHICLE"];
    const abolength = await store.getters["reservation/GET_ABO_LENGTH"];

    const monthLength =
      (await store.getters["ORMgeneral/GET_PARAMETER"](
        "SORM_DATE_END_VALUE"
      )) || "28";
    if (vehicle) {
      vehicle.prices.forEach((element) => {
        this.aboPerVehicle.push({
          key: element.months,
          value: abolength.find((x) => x.key == element.months)
            ? abolength.find((x) => x.key == element.months).value
            : monthLength * element.months,
        });
      });
      this.selectedAbo = await store.getters["reservation/GET_SELECTEDABO"];
    } else {
      this.aboPerVehicle = abolength;
      this.selectedAbo = await store.getters["reservation/GET_SELECTEDABO"];
    }

    store.watch(
      () => store.getters["stations/GET_OPENINGTIMES"],
      () => {
        this.selectedAbo = store.getters["reservation/GET_SELECTEDABO"];
      }
    );
  },

  methods: {
    async selectAbo(abo) {
      await store.dispatch("reservation/SET_ABOLENGTH", abo);
      await store.dispatch("stations/SET_OPENINGTIMES");
      // this.isLoading = true;
      this.selectedAbo = abo;
      this.$emit("update");
      // this.loadCarGroup();
    },
  },
});
</script>
